import axios from 'axios'
import { REACT_APP_API } from '../../config'
import { FIELD_TYPES } from 'common/hooks/useForm'
import { maskFuntions } from 'src/features/price-policies/constants'

export async function getAllConventionalBonificationsByStock({carlotSelected=[], stateFilters=[], vin=''}) {
  let query = ''
  carlotSelected.forEach(carLot => {
      query = query + `car_lot_id[]=${carLot}&`
  })

  stateFilters.forEach((filter)=> {
    if(filter.type === FIELD_TYPES.CHECKBOXES){
      query = query + `${filter.keyBackend}[]=${filter.value}&`
    } else {
      query = query + `${filter.keyBackend}=${maskFuntions.removeMask(filter.value)}&`
    }
  })

  if (vin) {
    query = query + `vin=${vin}&`
  }

  query = query.slice(0, -1)

  const response = await axios(
      `${REACT_APP_API}/bonifications/conventional/stock?${query}`
  )

  return response?.data?.data || []
}
